import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import Logo from '../../../public/images/header_logo_white.svg';
import { getAuthToken } from '../../shared/auth';
import Avatar from './avatar';

class Layout extends Component {
  componentWillMount() {
    document.body.classList.add('mozer_theme');
  }

  componentWillUnmount() {
    document.body.classList.remove('mozer_theme');
  }

  render() {
    const {
      children,
      onToastClose,
      toast,
      playerSettings,
      handleLogout,
      handleProfile,
    } = this.props;
    const token = getAuthToken();
    const isAuth = token && Object.keys(playerSettings).length !== 0;
    return (
      <React.Fragment>
        <header>
          <div className="container">
            <h1>
              {isAuth ? (
                <Link to="login" >
                  <img className="logo" src={Logo} alt="LifeisTechLesson" />
                </Link>
              ) : (
                <Link to="home" >
                  <img className="logo" src={Logo} alt="LifeisTechLesson" />
                </Link>
              )}
            </h1>
            <div className="account" >
              <p>Web Design Course</p>
              <Avatar
                avatarFileName={playerSettings.avatarFileName}
                nickname={playerSettings.nickname}
                handleProfile={handleProfile}
              />
              {isAuth ? (
                <p className="login-area" >
                  <Button className="btn-logout" onClick={handleLogout} >
                    Logout
                  </Button>
                </p>
              ) : (
                <p className="login-area" >
                  <Link className="btn-login" to="login" >
                    Login
                  </Link>
                </p>
              )}
            </div>
          </div>
        </header>
        <Alert color={toast.toastType} isOpen={toast.isOpen} toggle={onToastClose} className="w-80 mx-auto mt-5">
          {toast.text}
        </Alert>
        { children }
      </React.Fragment>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onToastClose: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleProfile: PropTypes.func.isRequired,
  toast: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    toastType: PropTypes.string.isRequired,
  }).isRequired,
  playerSettings: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Layout;
